<template>
  <div class="log-oppea-box">
    <div class="item">操作用户：{{rowItem.operatedUserPO.realName}}</div>
    <div class="item">被操作对象：{{form && form.updateTag}}</div>
    <div class="item">修改时间：{{rowItem.operatedTime}}</div>
    <el-row v-if="form">
      <el-col :span="12" v-if="form.beforeStr">
        <div class="grid-content">
          <div class="title">变更前</div>
          <!-- <div class="title-box"><span class="txt1">客户信息</span></div> -->
          <div class="item">客户姓名：{{form.beforeStr.data0.customer_name}}</div>
          <div class="item">客户电话：{{form.beforeStr.data0.customer_phone}}</div>
          <div class="item">门店类型：{{form.beforeStr.data0.store_type}}</div>
          <div class="item">企业名称：{{form.beforeStr.data0.company_name}}</div>
          <div class="item">日均门诊量：{{form.beforeStr.data0.daily_outpatient_visits}}</div>
          <div class="item">员工数量：{{form.beforeStr.data0.staff_num}}</div>
          <div class="item">正在开展项目：{{form.beforeStr.data0.project_id}}</div>
          <div class="item">微信号：{{form.beforeStr.data0.wechat_number}}</div>
          <div class="item">意向度：{{form.beforeStr.data0.intentionality==1?'高':form.beforeStr.data0.intentionality==2?'中':'低'}}</div>
          <div class="item">备注：{{form.beforeStr.data0.remark}}</div>
        </div>
      </el-col>
      <el-col :span="12" v-if="form.afterStr">
        <div class="grid-content log-line">
          <div class="title">变更后</div>
          <!-- <div class="title-box"><span class="txt1">客户信息</span></div> -->
          <div class="item">客户姓名：{{form.afterStr.data0.customer_name}}</div>
          <div class="item">客户电话：{{form.afterStr.data0.customer_phone}}</div>
          <div class="item">门店类型：{{form.afterStr.data0.store_type}}</div>
          <div class="item">企业名称：{{form.afterStr.data0.company_name}}</div>
          <div class="item">日均门诊量：{{form.afterStr.data0.daily_outpatient_visits}}</div>
          <div class="item">员工数量：{{form.afterStr.data0.staff_num}}</div>
          <div class="item">正在开展项目：{{form.afterStr.data0.project_id}}</div>
          <div class="item">微信号：{{form.afterStr.data0.wechat_number}}</div>
          <div class="item">意向度：{{form.afterStr.data0.intentionality==1?'高':form.afterStr.data0.intentionality==2?'中':'低'}}</div>
          <div class="item">备注：{{form.afterStr.data0.remark}}</div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import sysDataCompareLogApi from '@/api/log/sysDataCompareLog'
export default {
  props: ['rowItem'],
  data() {
    return {
      form: null
    }
  },
  created() {
    this.getLogShow()
  },
  methods: {
    getLogShow() {
      sysDataCompareLogApi.fetchById(this.rowItem.id).then(res => {
        this.form = res.data;
      })
    }
  }

}
</script>

<style lang="scss" scoped>
.title-box {
  margin: 10px 24px 15px 0;
  &::after {
    content: '';
    display: table;
    clear: both;
  }
  .txt1 {
    font-size: 16px;
    // font-weight: bold;
    color: #000000;
    position: relative;
    padding-left: 5px;
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 3px;
      bottom: 0;
      width: 4px;
      background: #5dbde7;
      border-radius: 6px;
    }
  }
  .txt2 {
    font-size: 12px;
    color: #8f8e8e;
    padding-left: 7px;
  }
  .fr {
    float: right;
    font-size: 16px;
    color: #1596cd;
  }
}
</style>
